import { Wind } from "lucide-react";
import { type QuizConfig } from "~/types/quiz";

export const procenaAnksioznosti: QuizConfig = {
  id: "procena-anksioznosti",
  illustration: {
    src: "/images/quizzes/procena-anksioznosti.webp",
    alt: "Žena sa ključevima zastaje na vratima pre izlaska.",
  },
  lastModified: "2026-10-05",
  title: "Koliko te anksioznost ograničava?",
  shortTitle: "Test anksioznosti",
  description:
    "Besplatan test anksioznosti koji otkriva koliko te anksioznost ograničava i daje konkretne korake za kontrolu.",
  longDescription:
    "Detaljna procena koja prepoznaje kako anksioznost utiče na tvoje telo, misli, fokus i odnose. Kroz kratka pitanja otkrivamo koji okidači te najviše pogađaju, šta ti se dešava u telu i koliko ti je teško da funkcionišeš kada se panika pojača. Na kraju dobijaš konkretne tehnike disanja, rad sa mislima koje hrane strah i preporuku kada je pravi trenutak da uključiš terapeuta ili promeniš dnevne navike.",
  icon: Wind,
  duration: "4-6 min",
  category: "Mentalno zdravlje",
  focusAreasWanted: [
    "anxiety",
    "emotional_regulation",
    "panic_attacks",
    "stress",
  ],
  featured: true,
  questions: [
    {
      type: "radio",
      question: "Pol:",
      options: ["Muški", "Ženski", "Ne želim da se izjasnim"],
      scores: [0, 0, 0],
    },
    {
      type: "radio",
      question: "Koliko često osećaš nemir ili napetost?",
      options: [
        "Nikad",
        "Nekoliko puta mesečno",
        "Nekoliko puta nedeljno",
        "Skoro svaki dan",
        "Više puta dnevno",
      ],
      scores: [0, 1, 2, 3, 4],
    },
    {
      type: "checkbox",
      checkboxScoring: "sum",
      question:
        "Koje fizičke znake anksioznosti primećuješ? (označi sve što važi)",
      options: [
        "Srce ti ubrzano lupa",
        "Znojiš se",
        "Drhtiš",
        "Vrti ti se u glavi",
        "Muka ti je",
        "Teško dišeš",
        "Ništa od ovoga",
      ],
      scores: [1, 1, 1, 1, 1, 1, 0],
    },
    {
      type: "radio",
      question: "Da li ti anksioznost smeta u svakodnevnim aktivnostima?",
      options: ["Ne uopšte", "Retko", "Ponekad", "Često", "Stalno"],
      scores: [0, 1, 2, 3, 4],
    },
    {
      type: "checkbox",
      checkboxScoring: "sum",
      question: "Šta ti najčešće izaziva anksioznost? (označi sve što važi)",
      options: [
        "Druženje sa ljudima",
        "Obaveze na poslu/fakultetu",
        "Brige oko zdravlja",
        "Novčane brige",
        "Razmišljanje o budućnosti",
        "Svađe i konflikti",
        "Nemam posebne okidače",
      ],
      scores: [1, 1, 1, 1, 1, 1, 0],
    },
    {
      type: "radio",
      question: "Koliko često imaš napade panike?",
      options: ["Nikad", "Retko", "Mesečno", "Nedeljno", "Više puta nedeljno"],
      scores: [0, 1, 2, 3, 4],
    },
    {
      type: "radio",
      question: "Kako se nosiš sa anksioznošću?",
      options: [
        "Imam dobre načine da je kontrolišem",
        "Uglavnom se snalazim",
        "Ponekad mi je teško",
        "Često me savlada",
        "Ne umem da se nosim sa njom",
      ],
      scores: [0, 1, 2, 3, 4],
    },
    {
      type: "checkbox",
      checkboxScoring: "context",
      question: "Šta ti pomaže kad si anksiozan/na? (označi sve što važi)",
      options: [
        "Razgovor sa bliskom osobom",
        "Vežbe disanja",
        "Šetnja ili fizička aktivnost",
        "Meditacija ili joga",
        "Muzika ili čitanje",
        "Ništa mi posebno ne pomaže",
      ],
      scores: [1, 1, 1, 1, 1, 0],
    },
    {
      type: "textarea",
      question: "Opiši kako anksioznost utiče na tvoj život:",
    },
    {
      type: "radio",
      question: "Koliko često imaš problema sa spavanjem zbog anksioznosti?",
      options: [
        "Nikad",
        "Retko",
        "Nekoliko puta mesečno",
        "Nekoliko puta nedeljno",
        "Skoro svaku noć",
      ],
      scores: [0, 1, 2, 3, 4],
    },
    {
      type: "radio",
      question: "Da li izbegavaš određene situacije zbog anksioznosti?",
      options: [
        "Ne izbegavam ništa",
        "Retko izbegavam",
        "Ponekad izbegavam",
        "Često izbegavam",
        "Izbegavam mnoge situacije",
      ],
      scores: [0, 1, 2, 3, 4],
    },
    {
      type: "checkbox",
      checkboxScoring: "sum",
      question: "Koje misli te muče kad si anksiozan/na? (označi sve što važi)",
      options: [
        "Strah da ću izgubiti kontrolu",
        "Briga da će se desiti nešto loše",
        "Osećaj da nisam dovoljno dobar/dobra",
        "Strah od osude drugih",
        "Briga o zdravlju bližnjih",
        "Katastrofične misli o budućnosti",
        "Nemam takve misli",
      ],
      scores: [1, 1, 1, 1, 1, 1, 0],
    },
  ],
  copy: {
    title: "Tvoj nivo anksioznosti",
    subtitle: "Razumevanje tvoje anksioznosti",
    scoreLabel: "Tvoj rezultat:",
    adviceTitle: "Saveti za tebe",
    resourcesTitle: "Korisni resursi",
    whatNextTitle: "Šta dalje?",
    shareButtonText: "Podeli rezultat",
  },
};
